import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=3b1e736e&scoped=true"
import script from "./msg.vue?vue&type=script&lang=js"
export * from "./msg.vue?vue&type=script&lang=js"
import style0 from "./msg.vue?vue&type=style&index=0&id=3b1e736e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e736e",
  null
  
)

export default component.exports